import React from "react";
import { SubTitle, SubTitleSpan } from "../../style/common.style";
export default function CustomSubTitle(props) {
  return (
    <SubTitle {...props}>
      {props.title + " " + props.titleSpan} <SubTitleSpan>{}</SubTitleSpan>
    </SubTitle>
  );
}
